import { indexItems, cardItems, rankingItems } from '@/mocks/home';

export function IndexSection() {
  return (
    <section id="index" className="py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-4">特色频道索引</h2>
          <p className="text-foreground-600 max-w-[600px] mx-auto">精选合作频道快速导航，找到你感兴趣的内容类型</p>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3 md:gap-4">
          {indexItems.map((item, i) => (
            <a
              key={i}
              href={item.title === '全部频道' ? '#ranking' : `#cards`}
              className="group flex flex-col items-center gap-3 bg-background-100 hover:bg-primary-50 rounded-xl p-5 md:p-6 transition-all duration-200 cursor-pointer no-underline"
              onClick={(e) => {
                if (item.title === '全部频道') {
                  e.preventDefault();
                  document.getElementById('ranking')?.scrollIntoView({ behavior: 'smooth' });
                } else {
                  e.preventDefault();
                  document.getElementById('cards')?.scrollIntoView({ behavior: 'smooth' });
                }
              }}
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-background-200 text-foreground-500 group-hover:bg-primary-500 group-hover:text-white transition-all duration-200">
                <i className={`${item.icon} text-xl`}></i>
              </div>
              <div className="text-center">
                <div className="text-sm font-bold text-foreground-800 group-hover:text-primary-500 transition-colors whitespace-nowrap">{item.title}</div>
                <div className="text-xs text-foreground-500 mt-1">{item.description}</div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}

export function CardsSection() {
  return (
    <section id="cards" className="py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-4">精选推荐</h2>
          <p className="text-foreground-600 max-w-[600px] mx-auto">编辑团队每日精选，为你推荐各频道不容错过的优质内容</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {cardItems.map((item, i) => (
            <div key={i} className={`group bg-background-50 rounded-2xl overflow-hidden transition-all duration-300 ${i === 0 ? 'sm:col-span-2 lg:col-span-3' : ''}`}>
              <div className={`flex flex-col ${i === 0 ? 'md:flex-row' : ''}`}>
                <div className={`relative overflow-hidden ${i === 0 ? 'md:w-[55%] aspect-[16/9] md:aspect-auto' : 'aspect-[16/10]'}`}>
                  <img
                    src={item.image}
                    alt={item.title}
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  />
                  <div className="absolute top-3 left-3 flex gap-2">
                    <span className="bg-primary-500 text-white text-xs px-2.5 py-1 rounded-full font-medium whitespace-nowrap">{item.tag}</span>
                    <span className="bg-background-50/90 backdrop-blur-sm text-foreground-800 text-xs px-2.5 py-1 rounded-full font-medium whitespace-nowrap">{item.channel}</span>
                  </div>
                </div>
                <div className={`p-5 md:p-6 ${i === 0 ? 'md:w-[45%] flex flex-col justify-center' : ''}`}>
                  <h3 className="font-heading text-lg font-bold text-foreground-900 mb-2 group-hover:text-primary-500 transition-colors">{item.title}</h3>
                  <p className="text-sm text-foreground-600 leading-relaxed">{item.description}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export function RankingSection() {
  return (
    <section id="ranking" className="py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-4">热门榜单</h2>
          <p className="text-foreground-600 max-w-[600px] mx-auto">实时热度排行，看看大家都在看什么</p>
        </div>
        <div className="max-w-[700px] mx-auto">
          {rankingItems.map((item, i) => (
            <div
              key={i}
              className="flex items-center gap-4 px-4 md:px-6 py-4 hover:bg-background-100 rounded-xl transition-colors cursor-pointer group"
            >
              <div className={`w-8 h-8 flex items-center justify-center rounded-lg font-heading text-sm font-bold flex-shrink-0 ${
                i < 3 ? 'bg-primary-500 text-white' : 'bg-background-200 text-foreground-500'
              }`}>
                {item.rank}
              </div>
              <div className="flex-1 min-w-0">
                <div className="text-sm font-semibold text-foreground-800 group-hover:text-primary-500 transition-colors truncate">{item.title}</div>
                <div className="flex items-center gap-2 mt-1">
                  <span className="text-xs text-foreground-500">{item.channel}</span>
                  <span className="inline-flex bg-secondary-100 text-secondary-700 text-xs px-2 py-0.5 rounded-full font-medium whitespace-nowrap">{item.tag}</span>
                </div>
              </div>
              <div className="flex items-center gap-1 text-accent-500 font-heading text-lg font-bold flex-shrink-0">
                {item.hot}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}